import 'css-chunk:../node_modules/.pnpm/cropperjs@1.5.12/node_modules/cropperjs/dist/cropper.css';export default {};